export const VEHICLE_ADD_NOTIFICATION = {
  TITLE: 'A car has been successfully added',
}
